<template>
  <main class="container">
    <div class="breadCrumb_modern_box">
      <div class="container">
        <ul class="breadcrumb">
          <li class="crumb_path">
            <a href="/">{{ this.$t("home12") }}</a>
          </li>
          <li class="crumb_path">
            <a href="/machinery">{{ this.$t("machinery12") }}</a>
          </li>
          <li class="crumb_path">
            <a href="/machinery/assemblemachine">{{ this.$t("assemblemachine12") }}</a>
          </li>
          <li class="active">
            <h1 class="breadcrumb_h1">{{ this.$t("cn_oa") }}</h1>
            <!--機器代號-->
          </li>
        </ul>
      </div>
    </div>
    <div class="col2">
      <img
        src="../../../assets/img/MachineImg/黃油嘴與本體組立機_logo.svg"
        alt="黃油嘴與本體組立機"
      /><!--機器中文名稱-->
    </div>
<!--    <div class="col1">
      <h3>{{ this.$t("Specification12") }}</h3>
      <table>
        
        <td>
        </td>
      </table>
    </div>  -->
    <div class="col1">
      <h3>{{ this.$t("Video12") }}</h3>
      <div class="row2">
        <video id="machine-video" class="video-js" controls>
          <!--小短片-->
          <source
            src="../../../assets/video/CN_OA/黃油嘴與本體組立機_1.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
    <div class="col1">
      <h3>{{ this.$t("FinishedProduct12") }}</h3>
      <!--螺絲成品-->
      <img
        src="../../../assets/img/MachineImg/Moonlit_Asteroid_product_黃油嘴與本體組立機.svg"
        alt="黃油嘴與本體組立機成品"
      />
    </div>
  </main>
</template>

<script>
export default {
  name: "CN_OA",
};
</script>

<style scoped lang="stylus">
.breadCrumb_modern_box
  background-color: transparent;
  margin-left:  11.5vmin;
  margin-right: 60vmin;
  width:  100vmin;
  height: 10vmin;
  position: relative;
  left: -3.5vmin;
  top:  -14vmin;
  text-align: left;

*
  -webkit-box-sizing: border-box;
  -moz-box-sizing:  border-box;
  box-sizing: border-box;

.container
  max-width:  100%;

ul
  margin-top: 0;
  margin-bottom:  10px;

.breadcrumb
  padding:  8px 15px;
  list-style: none;
  background-color: #f5f5f5;
  border-radius:  4px;

@media (min-width:  326px)
  .breadcrumb
    background-color: rgba(0,0,0,0);
    padding:  15px 0px;
    margin-top: 20vmin;
    margin-bottom:  10vmin;
    font-size:    2.5vmin;

.breadcrumb>li
  display:  inline-block;

a
  background-color: transparent;
  color:  #337ab7;
  text-decoration:  none;

.breadcrumb>.active
  color:  #000;

.breadcrumb_h1
  font-size:  initial;
  display:  inline;
  color:  inherit;
  font-family:  inherit;

.breadcrumb .active h1.breadcrumb_h1
  font-size:  2.5vmin;

.breadcrumb>li+li:before
  padding:  0 5px;
  color:  #000;
  content:  "/\00a0"

@media (min-width:  326px)
  .col1
    display:  flex;
    flex-wrap:  wrap;
    margin-left:  10vmin;

  .col1 h3
    font-size:  6vmin;
    display:  table-row-group;
    width:  auto

  .row2
    margin: 15vmin 0vmin 0vmin 0vmin;
    width:  50%;
    height: auto;

  .video-js
    width:  100%;
    height: auto;
    margin: 8vmin 0vmin 0vmin 0vmin;
    min-width: 400px;

  .col1 img
    width:  50%;
    height: auto;
    margin: 15vmin 0vmin 0vmin 0vmin;

  .col2
    font-size:  0;
    display:  flex;
    margin-top: -24vmin;
    margin-left:  12vmin;

  .col2 img
    margin: 10vmin 10vmin auto 10vmin;
    border: 3px solid rgba(0,0,0,.7);
    width:  50vmin;
    height: 50vmin;

  table
    margin: 15vmin 0vmin auto 0vmin;
    border: 3px solid rgba(0,0,0,.7);
    width:  auto;
    height: auto;

  td
    font-size:  4vmin;
    color:  #000;
    border: 1px solid rgba(0,0,0,.7);
    width:  auto;
  .unit
    font-size:  3vmin;
  th
    font-size:  4vmin;
</style>
